import { Card } from '@/common/ui/Card'
import { SupportForm } from '@/app/entities/support'

export const SupportPage = () => {
    return (
        <>
            <div className='profile-content'>
                <h2 className='font-medium text-[20px]/[22px]'>Написать в поддержку</h2>
            </div>
            <Card className='profile-content card-primary'>
                <SupportForm />
            </Card>
        </>
    )
}
